var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2226_35149",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 24,
    width: 166,
    height: 152
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.505 75.3102L102.497 173.885C101.643 174.95 101.216 175.482 100.701 175.675C100.249 175.844 99.7511 175.844 99.2991 175.675C98.7836 175.482 98.3568 174.95 97.5031 173.885L18.4948 75.3102C17.9586 74.6412 17.6905 74.3067 17.5788 73.9333C17.4802 73.6037 17.4682 73.2542 17.5442 72.9186C17.6302 72.5385 17.8748 72.1865 18.3642 71.4825L37.4082 44.0833C37.5359 43.8995 37.5998 43.8076 37.6729 43.7239C37.7379 43.6496 37.8083 43.5802 37.8835 43.5163C37.9682 43.4443 38.061 43.3817 38.2465 43.2566L38.2466 43.2566L58.0005 29.9344C58.1871 29.8086 58.2805 29.7456 58.3795 29.6938C58.4675 29.6478 58.5588 29.6084 58.6527 29.576C58.7583 29.5395 58.8682 29.5148 59.0878 29.4654L59.0878 29.4654L78.9742 24.9949L78.9743 24.9949C79.0776 24.9717 79.1292 24.9601 79.1814 24.9512C79.2277 24.9434 79.2743 24.9371 79.321 24.9325C79.3737 24.9274 79.4266 24.925 79.5324 24.9202L100 24L120.468 24.9202C120.573 24.925 120.626 24.9274 120.679 24.9325C120.726 24.9371 120.772 24.9434 120.819 24.9512C120.871 24.9601 120.922 24.9717 121.026 24.9949L140.912 29.4654C141.132 29.5148 141.242 29.5395 141.347 29.576C141.441 29.6084 141.532 29.6478 141.62 29.6938C141.72 29.7456 141.813 29.8085 141.999 29.9344L142 29.9344L161.753 43.2566L161.754 43.2567C161.939 43.3818 162.032 43.4443 162.116 43.5163C162.192 43.5802 162.262 43.6496 162.327 43.7239C162.4 43.8076 162.464 43.8995 162.592 44.0833L181.636 71.4825C182.125 72.1865 182.37 72.5385 182.456 72.9186C182.532 73.2542 182.52 73.6037 182.421 73.9333C182.309 74.3067 182.041 74.6412 181.505 75.3102Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2226_35149)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 200,
    height: 200,
    fill: "#7EC7FF",
    style: {
      mixBlendMode: "hue"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9771 23.0676H166.023V58.5188H33.9771V23.0676Z",
    fill: "#7EC7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 58.5188L126.409 87.4395H73.5908L99.9999 58.5188Z",
    fill: "#75C1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3518 50.1224L16.9995 73.4456L41.5222 79.5096L44.3518 50.1224Z",
    fill: "#7AC6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5906 56.6529L41.5225 79.5096L73.5906 87.4395V56.6529Z",
    fill: "#8FCEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.409 56.653L158.477 79.5097L126.409 87.4395V56.653Z",
    fill: "#8FCEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5229 79.5096L73.5911 56.6529L44.3525 50.1224L41.5229 79.5096Z",
    fill: "#47A9F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.477 79.5096L126.409 56.6529L155.647 50.1224L158.477 79.5096Z",
    fill: "#47A9F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.648 50.1224L183 73.4456L158.477 79.5096L155.648 50.1224Z",
    fill: "#7AC6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7494 43.5927L16.9995 73.4464L44.3518 50.1232L37.7494 43.5927Z",
    fill: "#47A9F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.25 43.5919L183 73.4456L155.648 50.1224L162.25 43.5919Z",
    fill: "#47A9F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183 73.4456L100 177L126.409 87.4395L183 73.4456Z",
    fill: "#47A9F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 73.445L100 177L73.5909 87.4389L17 73.445Z",
    fill: "#47A9F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17 73.4456L95.2841 177L41.5227 79.5096L17 73.4456Z",
    fill: "#309FF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183 73.4456L104.716 177L158.477 79.5096L183 73.4456Z",
    fill: "#309FF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5908 87.4395L99.9999 190.061L126.409 87.4395L73.5908 87.4395Z",
    fill: "#8DCCFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 87.4395L84.5129 129.888L73.5908 87.4395H99.9999Z",
    fill: "#BFE2F7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100 87.4395L115.487 129.888L126.409 87.4395H100Z",
    fill: "#BFE2F7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5903 87.4395V56.6529L99.9994 58.5188L73.5903 87.4395Z",
    fill: "#99D1FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.409 87.4395V56.6529L100 58.5188L126.409 87.4395Z",
    fill: "#99D1FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7954 72.9791L99.9999 58.5188L73.5908 56.6529L86.7954 72.9791Z",
    fill: "#ADDCFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.205 72.9791L100 58.5188L126.409 56.6529L113.205 72.9791Z",
    fill: "#ADDCFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.9914a0ef.svg";
export { ForwardRef as ReactComponent };